import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const ShieldIcon = ({
  width = "18",
  height = "18",
  color = "#0097DD",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} color={color}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.47651 16.2109C8.64255 16.3078 8.72557 16.3562 8.84274 16.3814C8.93367 16.4009 9.06633 16.4009 9.15726 16.3814C9.27443 16.3562 9.35745 16.3078 9.52349 16.2109C10.9845 15.3586 15 12.6811 15 8.99978V5.41298C15 4.81335 15 4.51353 14.9019 4.25581C14.8153 4.02814 14.6745 3.82499 14.4918 3.66393C14.2849 3.48161 14.0042 3.37634 13.4427 3.16579L9.42135 1.65779C9.26543 1.59932 9.18747 1.57008 9.10726 1.55849C9.03612 1.54821 8.96388 1.54821 8.89274 1.55849C8.81253 1.57008 8.73457 1.59932 8.57865 1.65779L4.5573 3.16579C3.99585 3.37634 3.71512 3.48161 3.50824 3.66393C3.32549 3.82499 3.18471 4.02814 3.09807 4.25581C3 4.51353 3 4.81335 3 5.41298V8.99978C3 12.6811 7.01547 15.3586 8.47651 16.2109Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
};
